const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/knowledge',
    translationKey: dummy_t('menu.knowledge'),
  },
  {
    externalPath: {
      'en-US': 'https://shestrong.zendesk.com/hc/en-us',
      'sv-SE': 'https://shestrongse.zendesk.com/hc/sv-se',
    },
    translationKey: dummy_t('footer.contact'),
  },
];
